import { createFileRoute } from "@tanstack/react-router"
import { PendingApprovalsView } from "@/features/overtime";

export const Route = createFileRoute("/pending-approvals")({
  component: PendingApprovalsPage,
});

function PendingApprovalsPage() {
  return <PendingApprovalsView />;
}
